/**
 * Données démo classes / événements / présences — Phase 1 local.
 * Aucun horaire officiel inventé.
 */

import { SEED_STUDENT_MARCEL_ID, seedResponsibleId } from "./phase1InitialSeed046.js";

/** @type {import('./types.js').ClassCourse[]} */
export const demoClasses = [
  {
    id: "demo-class-01",
    nom: "[DÉMO] Enfants débutants",
    dojo_id: "demo-dojo-01",
    groupe: "Enfants 8–11",
    categorie: "enfants",
    niveau: "Débutant",
    instructeur_id: "demo-sensei-placeholder",
    assistant_id: seedResponsibleId(1),
    jour: "lundi",
    heure_debut: "18:00",
    heure_fin: "19:00",
    statut: "actif",
    phase: "phase1",
    notes: "Horaire démo — fichier officiel en attente.",
    demo: true,
  },
  {
    id: "demo-class-02",
    nom: "[DÉMO] Ados / adultes",
    dojo_id: "demo-dojo-01",
    groupe: "Adultes",
    categorie: "adultes",
    niveau: "Tous niveaux",
    instructeur_id: "demo-sensei-placeholder",
    assistant_id: seedResponsibleId(1),
    jour: "mercredi",
    heure_debut: "19:00",
    heure_fin: "20:30",
    statut: "actif",
    phase: "phase1",
    notes: "Cours mixte ados/adultes — démo.",
    demo: true,
  },
  {
    id: "demo-class-03",
    nom: "[DÉMO] Ceintures avancées",
    dojo_id: "demo-dojo-01",
    groupe: "Avancés",
    categorie: "ceintures_avancees",
    niveau: "Brune et plus",
    instructeur_id: "demo-sensei-placeholder",
    assistant_id: null,
    jour: "samedi",
    heure_debut: "10:00",
    heure_fin: "11:30",
    statut: "actif",
    phase: "phase1",
    notes: "Groupe technique — démo.",
    demo: true,
  },
  {
    id: "demo-class-04",
    nom: "[DÉMO] Équipe compétition — à venir",
    dojo_id: "demo-dojo-01",
    groupe: "Compétition",
    categorie: "competition",
    niveau: "Sélection",
    instructeur_id: "demo-sensei-placeholder",
    assistant_id: seedResponsibleId(1),
    jour: "vendredi",
    heure_debut: "18:30",
    heure_fin: "20:00",
    statut: "a_confirmer",
    phase: "phase2",
    notes: "Phase 2 — structure préparée.",
    demo: true,
  },
];

/** @type {import('./types.js').DojoEvent[]} */
export const demoEvents = [
  {
    id: "demo-event-01",
    type: "seminaire",
    titre: "[DÉMO] Séminaire techniques katas",
    date: "2026-09-15",
    dojo_id: "demo-dojo-01",
    audience: "Tous membres",
    visibilite: "membres",
    statut: "actif",
    phase: "phase1",
    notes: "Événement démo — dates à confirmer.",
    demo: true,
  },
  {
    id: "demo-event-02",
    type: "stage",
    titre: "[DÉMO] Stage week-end",
    date: "2026-10-20",
    dojo_id: "demo-dojo-01",
    audience: "Adultes et ados",
    visibilite: "membres",
    statut: "actif",
    phase: "phase1",
    notes: "Stage démo.",
    demo: true,
  },
  {
    id: "demo-event-03",
    type: "camp",
    titre: "[DÉMO] Camp d'été",
    date: "2026-07-10",
    dojo_id: "demo-dojo-01",
    audience: "Enfants et ados",
    visibilite: "membres",
    statut: "a_confirmer",
    phase: "phase1",
    notes: "Camp — inscription future.",
    demo: true,
  },
  {
    id: "demo-event-04",
    type: "demonstration",
    titre: "[DÉMO] Démonstration publique",
    date: "2026-11-05",
    dojo_id: "demo-dojo-01",
    audience: "Public",
    visibilite: "public",
    statut: "actif",
    phase: "phase1",
    notes: "Démo communautaire.",
    demo: true,
  },
  {
    id: "demo-event-05",
    type: "examen",
    titre: "[DÉMO] Examens ceintures — à venir",
    date: "2026-12-01",
    dojo_id: "demo-dojo-01",
    audience: "Étudiants inscrits",
    visibilite: "membres",
    statut: "a_confirmer",
    phase: "futur",
    notes: "Module examens opérationnels — Phase 2+.",
    demo: true,
  },
  {
    id: "demo-event-06",
    type: "competition",
    titre: "[DÉMO] Compétition régionale — à venir",
    date: "2027-03-15",
    dojo_id: "demo-dojo-01",
    audience: "Équipe compétition",
    visibilite: "membres",
    statut: "a_confirmer",
    phase: "futur",
    notes: "Module compétitions complet — Phase 2+.",
    demo: true,
  },
];

/** Date de séance démo pour présences légères */
export const DEMO_ATTENDANCE_DATE = "2026-06-30";

/** @type {import('./types.js').LightAttendance[]} */
export const demoPresences = [
  {
    id: "att-demo-01",
    class_id: "demo-class-02",
    student_id: SEED_STUDENT_MARCEL_ID,
    date: DEMO_ATTENDANCE_DATE,
    statut: "present",
    note: "",
    demo: true,
  },
  {
    id: "att-demo-02",
    class_id: "demo-class-01",
    student_id: SEED_STUDENT_MARCEL_ID,
    date: DEMO_ATTENDANCE_DATE,
    statut: "non_suivi",
    note: "Groupe différent — démo",
    demo: true,
  },
];
